import { render, staticRenderFns } from "./InstitutionalQnrIntroView.vue?vue&type=template&id=0c3596e4&scoped=true&"
import script from "./InstitutionalQnrIntroView.vue?vue&type=script&lang=js&"
export * from "./InstitutionalQnrIntroView.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionalQnrIntroView.vue?vue&type=style&index=0&id=0c3596e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3596e4",
  null
  
)

export default component.exports